/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Form } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import useStoryUpdate from '../../hooks/useStoryUpdate';
import TrackingField from '../fields/Tracking';
// import ThemeUpdateField from '../fields/ThemeUpdate';

import { languageOptions } from '../../lib/languages';

const propTypes = {
    story: MicromagPropTypes.story.isRequired,
    className: PropTypes.string,
    fields: MicromagPropTypes.formFields,
    onCreated: PropTypes.func,
};

const defaultProps = {
    fields: [
        {
            type: 'fields',
            isSection: true,
            fields: [
                {
                    name: 'title',
                    type: 'text',
                    label: <FormattedMessage defaultMessage="Title" description="Field label" />,
                },
            ],
        },
        {
            type: 'fields',
            label: (
                <FormattedMessage defaultMessage="Metadata" description="Fields section label" />
            ),
            isSection: true,
            name: 'metadata',
            fields: [
                {
                    name: 'description',
                    type: 'text',
                    label: (
                        <FormattedMessage defaultMessage="Description" description="Field label" />
                    ),
                },
                {
                    name: 'favicon',
                    type: 'image',
                    label: <FormattedMessage defaultMessage="Favicon" description="Field label" />,
                },
                {
                    name: 'shareImage',
                    type: 'image',
                    label: <FormattedMessage defaultMessage="Share" description="Field label" />,
                },
                {
                    name: 'language',
                    type: 'select',
                    withoutReset: true,
                    label: <FormattedMessage defaultMessage="Language" description="Field label" />,
                    options: languageOptions,
                },
            ],
        },
        {
            type: 'fields',
            name: 'settings',
            fields: [
                {
                    type: 'fields',
                    label: (
                        <FormattedMessage
                            defaultMessage="Tracking"
                            description="Fields section label"
                        />
                    ),
                    isSection: true,
                    fields: [
                        {
                            name: 'tracking',
                            component: TrackingField,
                        },
                    ],
                },
            ],
        },
    ],
    className: null,
    onCreated: null,
};

const StorySettingsForm = ({ story, fields, className, onCreated }) => {
    const url = useUrlGenerator();
    const { update: updateStory } = useStoryUpdate(story.id);
    const postForm = useCallback((action, data) => updateStory(data), [updateStory]);
    const updateTheme = useCallback(
        (newTheme = null) => {
            if (newTheme !== null) {
                updateStory({ ...story, theme: newTheme });
            }
        },
        [story, updateStory],
    );

    const { theme } = story || {};
    const { id: themeId = null } = theme || {};

    return (
        <Form
            action={url('stories.update', { story: story.id })}
            fields={fields.map((f) => ({
                ...f,
                ...(f.name === 'theme'
                    ? {
                          fields: f.fields.map((sub) => ({
                              ...sub,
                              value: themeId,
                              updateTheme,
                              onChange: () => {},
                          })),
                      }
                    : null),
            }))}
            initialValue={story}
            postForm={postForm}
            submitButtonLabel={
                <FormattedMessage defaultMessage="Save" description="Button label" />
            }
            onComplete={onCreated}
            className={className}
        />
    );
};

StorySettingsForm.propTypes = propTypes;
StorySettingsForm.defaultProps = defaultProps;

export default StorySettingsForm;
